import { makeApiCall } from "../apiRequest";

export default {
  state: {
    lookupData: [],
    lookupCompleteData: [],
  },
  getters: {
    getMonths: (state) => {
      return state.lookupData.filter((item) => item.type === "Months");
    },

    getWeekDays: (state) => {
      return state.lookupData.filter((item) => item.type === "WeekDays");
    },

    getGender: (state) => {
      return state.lookupData.filter((item) => item.type === "Gender");
    },
    getTicketDependenciesStatus: (state) => {
      return state.lookupData.filter(
        (item) => item.type === "TicketDependenciesStatus"
      );
    },
    getLookupById(){
      return (state) => {
        return state.lookupCompleteData;
      };
    }
  },
  actions: {
    async fetchLookupData({ commit }, obj) {
      const response = await makeApiCall(`lookup/getAll`, "POST", obj);
      if (response.succeeded) {
        commit("setLookupData", response.data.data);
      }
      return response;
    },
    async fetchLookupCompleteData({ commit }, obj) {
      const response = await makeApiCall(`lookup/getAll`, "POST", obj);
      if (response.succeeded) {
        commit("setLookupCompleteData", response.data.data);
      }
      return response;
    },
  },
  mutations: {
    setLookupData(state, payload) {
      state.lookupData = payload;
    },
    setLookupCompleteData(state, payload) {
      state.lookupCompleteData = payload;
    },
  },
};
